module.exports = __webpack_public_path__ + "img/card26.b5538121.png";